var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNullable, IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsString } from 'class-validator';
import { CampaignExposeGroup } from '../interface';
export class ReadCampaignWorkflowInputFieldDto {
}
__decorate([
    ApiProperty({ example: 'orderId', type: () => String }),
    Expose({
        groups: [
            CampaignExposeGroup.MODEL,
            CampaignExposeGroup.READ,
            CampaignExposeGroup.CREATE,
            CampaignExposeGroup.UPDATE,
            CampaignExposeGroup.CONFIG,
            CampaignExposeGroup.START,
        ],
    }),
    IsNotEmpty({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    IsString({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    LengthWithLVS(3, 255, { groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    __metadata("design:type", String)
], ReadCampaignWorkflowInputFieldDto.prototype, "name", void 0);
__decorate([
    ApiPropertyOptional({ oneOf: [{ type: 'string' }, { type: 'number' }], example: '10', nullable: true }),
    Expose({
        groups: [
            CampaignExposeGroup.MODEL,
            CampaignExposeGroup.READ,
            CampaignExposeGroup.CREATE,
            CampaignExposeGroup.UPDATE,
            CampaignExposeGroup.CONFIG,
            CampaignExposeGroup.START,
        ],
    }),
    IsUndefinable({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    IsNullable({ groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START] }),
    __metadata("design:type", Object)
], ReadCampaignWorkflowInputFieldDto.prototype, "value", void 0);
//# sourceMappingURL=ReadCampaignWorkflowInputFieldDto.js.map